'use strict';

define(['app'], function (app) {

  var footerContactUs = function footerContactUs() {
    var component = {};

    var _config = {
      selectors: {
        levelOne: '[data-level-one]',
        levelTwo: '[data-level-two]',
        iconCollapse: '[data-icon=collapse]',
        iconExpand: '[data-icon=expand]'
      },
      attributes: {
        action: 'data-action' //do not call this toggle otherwise it will interfere with footerLinkColumns
      },
      classes: {
        levelTwoExpanded: 'footerContactUs_levelTwo-expanded',
        iconHide: 'footerContactUs_icon-hide'
      }
    };

    var _init = function _init(element) {
      component.element = element;
      component.levelOne = component.element.querySelector(component.config.selectors.levelOne);
      component.levelTwo = component.element.querySelector(component.config.selectors.levelTwo);
      component.collapseIcon = component.element.querySelector(component.config.selectors.iconCollapse);
      component.expandIcon = component.element.querySelector(component.config.selectors.iconExpand);

      component.addClickEventListener();
    };

    var _addClickEventListener = function _addClickEventListener() {
      component.levelOne.addEventListener('click', component.actionView);
    };

    var _actionView = function _actionView() {
      if (app.element.getAttribute(component.config.attributes.action, component.levelOne) === 'expand') {
        app.element.setAttribute(component.config.attributes.action, 'collapse', component.levelOne);
        component.expandView();
      } else {
        app.element.setAttribute(component.config.attributes.action, 'expand', component.levelOne);
        component.collapseView();
      }
    };

    var _expandView = function _expandView() {
      app.element.addClass(component.config.classes.levelTwoExpanded, component.levelTwo);
      app.element.removeClass(component.config.classes.iconHide, component.collapseIcon);
      app.element.addClass(component.config.classes.iconHide, component.expandIcon);
    };

    var _collapseView = function _collapseView() {
      app.element.removeClass(component.config.classes.levelTwoExpanded, component.levelTwo);
      app.element.addClass(component.config.classes.iconHide, component.collapseIcon);
      app.element.removeClass(component.config.classes.iconHide, component.expandIcon);
    };

    component.config = _config;
    component.init = _init;
    component.addClickEventListener = _addClickEventListener;
    component.actionView = _actionView;
    component.collapseView = _collapseView;
    component.expandView = _expandView;

    return component;
  };

  return footerContactUs;
});
//# sourceMappingURL=footerContactUs.js.map
